module.exports = __webpack_public_path__ + "media/images/icons/icn_051-2da58b554b7d031ce1848a6eb04adc2f.svg";